import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

import TravelBriefInfoRoute from './Info';

const routes: CustomRoute = {
	path: appPath.travelBrief.replace(appPath.travel, ''),
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'travelBrief' */ './component')],
			render: ([TravelBrief]) => <TravelBrief />,
		},
		TravelBriefInfoRoute,
	],
};

export default routes;
